<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  
  // mounted() {
  //   // Forçar a remoção do scroll horizontal
  //   document.documentElement.style.overflowX = 'hidden'
  //   document.body.style.overflowX = 'hidden'
  // },
  
  // beforeDestroy() {
  //   // Restaurar comportamento padrão
  //   document.documentElement.style.overflowX = ''
  //   document.body.style.overflowX = ''
  // }
}
</script>
<!-- 
<style>
html, 
body {
  overflow-x: hidden !important;
  max-width: 100vw;
  position: relative;
  margin: 0;
  padding: 0;
}

#app {
  overflow-x: hidden !important;
  max-width: 100vw;
  width: 100%;
  position: relative;
}

/* Ajustes para evitar sobreposição na navbar */
.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

/* Espaçamento para conteúdo abaixo de navbar fixa */
.navbar-fixed + * {
  padding-top: 60px; /* Ajustar conforme a altura da navbar */
}

/* Prevenção de scroll horizontal na aplicação inteira */
.columns {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100% !important;
}

</style> -->
